import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseManageConsulators() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      top: isEmpty(state.top),
      start: isEmpty(state.start),
      end: isEmpty(state.end),
      productID: isEmpty(state.brandID) && isEmpty(state.productID),
      brandID: isEmpty(state.brandID) && isEmpty(state.productID),
    };
    setter(errorState);

    if (errorState.top || errorState.start || errorState.end) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (errorState.productID && errorState.brandID) {
      enqueueSnackbar("لطفا یا محصول یا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetConsulators = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ManageConsulators?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetConsulatorById = (myPC, consultantId, callback) => {
    MyAxios.get(`Admin_ManageConsulators/${consultantId}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    validate,
    GetConsulators,
    GetConsulatorById,
  };
}
